import { usePump } from "@/context/PumpContext";

export const DEFAULT_PRODUCTS = [
  { key: "diesel", name: "Diesel (HSD)", short: "HSD", unit: "L", nozzles: ["diesel_a1", "diesel_b1"] },
  { key: "petrol", name: "Petrol (MS)", short: "MS", unit: "L", nozzles: ["petrol_a2", "petrol_b2"] },
  { key: "speed", name: "Speed Petrol", short: "Speed", unit: "L", nozzles: ["speed_a3", "speed_b3"] },
];

const PALETTE = ["#007BC9", "#FDB813", "#64748B", "#16A34A", "#DC2626", "#7C3AED", "#0891B2", "#EA580C"];

export function productColor(i) { return PALETTE[i % PALETTE.length]; }

export function nozzleLabel(p, i) { return `${p.short} N${i + 1}`; }

export function emptyReadings(products) {
  return Object.fromEntries(products.flatMap((p) => p.nozzles.map((n) => [n, ""])));
}

export function emptyTesting(products) {
  return { ...Object.fromEntries(products.map((p) => [p.key, 0])), remarks: "" };
}

/** Products for the current pump; prefer the products a shift was recorded with. */
export function useProducts(shift) {
  const { pump } = usePump();
  return shift?.products_used || pump?.products || DEFAULT_PRODUCTS;
}

export function unitLabel(products) {
  const units = [...new Set(products.map((p) => p.unit))];
  return units.length === 1 ? units[0] : "Qty";
}
